import * as React from 'react';

import { QuizUrl } from '../../../../api/quizApi';

const QuizUrlContext = React.createContext<QuizUrl>(undefined);

interface Props {
  quizUrl: QuizUrl;
  children: React.ReactNode;
}

export function QuizUrlContextProvider({ quizUrl, children }: Props) {
  return (
    <QuizUrlContext.Provider value={quizUrl}>
      {children}
    </QuizUrlContext.Provider>
  );
}

export function useQuizUrl() {
  const value = React.useContext(QuizUrlContext);
  if (value === undefined) {
    throw new Error('QuizUrl is not defined');
  }
  return value;
}
